(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menista-india-enquiry"]) return;
  try {
    
(function () {
  function initialiseIndiaEnquiry() {
    const root = document.getElementById('menista-india-enquiry');
    if (!root) return;
    const method = root.querySelector('#mie-method');
    const phoneField = root.querySelector('#mie-phone-field');
    const phone = root.querySelector('#mie-phone');
    if (!method || !phoneField || !phone || method.dataset.initialised) return;
    method.dataset.initialised = 'true';
    function updatePhoneField() {
      const needed = method.value !== 'Email';
      phoneField.hidden = !needed;
      phone.disabled = !needed;
      phone.required = needed;
    }
    method.addEventListener('change', updatePhoneField);
    updatePhoneField();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseIndiaEnquiry, { once: true });
  else initialiseIndiaEnquiry();
  document.addEventListener('shopify:section:load', initialiseIndiaEnquiry);
})();

  } catch(e) { console.error(e); }
})();
})();
